import React from 'react';

export const UnderlyingPriceExitDocumentation = (
  <>
    <p>
      Underlying Price Exit is an exit tactic used for adding price targets on
      the underlying price. In a stock trade, this will simply add orders at the
      defined price levels. For an option trade, it will place targets on the
      underlying price that can be modified in the tactic panel after creation
      or entry.
    </p>
    <p>
      <strong>Parameters</strong>
    </p>
    <p>
      <strong>Price | Pct. per Level: </strong>
      Each level is defined by a price and percentage pair. The percentage
      determines what percentage of the current position size should be closed at
      the defined price level. You must add at least one of these pairs to use
      this tactic. It is advised that you consult the current underlying price
      to ensure that all levels are above the current price(below for a short
      trade).
    </p>
  </>
);
